//Giving user the ability to add logo,colors,number and different UI for their app.

// Library Utilities
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Accordion } from "react-bootstrap";

// Components
import Toast from "../../../../Shared/toast/toast";
import ZpinMainPopup from "../../../../Shared/zpin-main-popup/zpinMainPopup";
import UnsavedChangesPopUp from "./unsaved-changes-pop-up/unsavedChangesPopUp";
import IpWhiteListing from "./ip-whiteListing/ipWhiteListing";

// Hooks
import { useTitle } from "../../../../Shared/useTitle";

// Constants
import ArrowUp from "../../../../Shared/svg/arrowUp";

// Functions
import { isValidIp } from "../../../../utils/validation";
import { callApi } from "../../../../api/fetch";
import { sendAuthOtp, OTP_PURPOSE } from "../../../../utils/otpApi";
import { getCurrentUserId } from "../../../../utils/authSession";
import { unwrapListData } from "../../../../utils/dashboardMappers";

// Styles
import Styles from "./app-settings.module.scss";
import { BLACKCOLOR } from "../../../../Shared/colors";
import { testIdProps } from "../../../../utils/testIdProps";

function AppSettings() {
  const {
    state: { id: appId },
  }: any = useLocation();
  const history = useNavigate();
  const [activeKey, setActiveKey] = useState("1");
  const [errorMessage, setErrorMessage] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [ipAddresses, setIPAddresses] = useState("");

  const [relayId, setRelayId] = useState("");
  const [allIpWhitelisted, setAllIpWhitelisted] = useState(false);
  const [savedIpCount, setSavedIpCount] = useState(0);
  const [enableAddingIpAddress, setEnableAddingIpAddress] =
    useState(true);
  const [zpinExists, setZpinExists] = useState(false);
  const [listOfIpAddress, setListOfIpAddress] = useState<string[]>([]);
  const [updatedListOfIpAddress, setUpdatedListOfIpAddress] = useState<
    string[]
  >([]);
  const [listOfRemovedIpAddress, setListOfRemovedIpAddress] =
    useState<any>([]);
  const [isIpAddressUpdated, setIsIpAddressUpdated] = useState(false);
  // const [showGatewayUISetting, setShowGatewayUISetting] = useState(false);
  const [saveAllPopUp, setSaveAllPopUp] = useState({
    show: false,
    unsavedSettings: [],
  });
  const [toggleOtpVerificationPopUp, setToggleOtpVerificationPopUp] =
    useState<any>({
      toggle: false,
      ips: [],
    });
  const [error, setError] = useState({
    backgroundColorError: "",
    buttonColorError: "",
    companyNameError: "",
    msisdnNumberError: "",
    appLogoError: "",
    ipAddress: "",
  });
  const [toggleResetOtp, setToggleResetOtp] = useState(false);
  const orgId = localStorage.getItem("organisation_id");

  async function getAppIpsById() {
    try {
      const appData = await callApi(`/apps/${appId}`, { method: "GET" });
      const { ip_whitelisted = [] } = appData as {
        ip_whitelisted?: string[];
      };
      setListOfIpAddress(ip_whitelisted);
      setUpdatedListOfIpAddress(ip_whitelisted);
      setAllIpWhitelisted(
        ip_whitelisted.length !== 0 && ip_whitelisted[0] !== "ALL"
      );
      setSavedIpCount(
        ip_whitelisted[0] === "ALL" ? 0 : ip_whitelisted.length
      );
    } catch (err: any) {
      toastTimeout(true, "error", err.message);
      history(`/application/manage-apps/${appId}/`);
    }
  }

  useEffect(() => {
    getAppIpsById();
  }, []);

  useEffect(() => {
    async function checkForZpin() {
      try {
        const userId = getCurrentUserId();
        if (!userId) return;
        const data = await callApi(
          `/zpins?user_pid=${encodeURIComponent(userId)}`,
          { method: "GET" }
        );
        const zpins = unwrapListData<Record<string, unknown>>(data, "zpins");
        if (zpins.length > 0) setZpinExists(true);
      } catch (error) {
        setZpinExists(false);
      }
    }
    checkForZpin();
  }, [orgId]);

  useEffect(() => {
    if (listOfIpAddress[0] === "ALL") {
      setAllIpWhitelisted(false);
    }
  }, [listOfIpAddress]);

  // Custom Toggle function here
  function CustomToggle({ onClick, eventKey, header }: any) {
    return (
      <div
        {...testIdProps(`manage-apps-settings-toggle-${eventKey}`)}
        className={
          activeKey.includes(eventKey)
            ? Styles.activeToggle
            : Styles.customToggle
        }
        // style={{ boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)" }}
        onClick={onClick}
      >
        <div
          className="d-flex align-items-center"
          style={{
            cursor: "pointer",
            position: "relative",
            zIndex: 1,
          }}
        >
          <div className="px-3 flex-grow-1 px-4 pb-2 pt-4">
            <p className={"mb-0 card_title_bold_text"}>{header}</p>
          </div>
          {/* <div className="px-2">
            {activeKey === eventKey ? (
              <ArrowDown />
            ) : (
              <div className={Styles.rotateArrowRight}>
                <ArrowDown />
              </div>
            )}
          </div> */}
        </div>
      </div>
    );
  }

  function toastTimeout(
    showToastValue: boolean,
    toastType: "success" | "error",
    toastMessage: string | string[],
    heading?: string
  ) {
    if (!showToastValue) return;

    // Show toast via react-toastify
    Toast(
      toastType,
      toastMessage,
      heading || (toastType === "success" ? "Success" : "Error")
    );
  }

  function handleBackNavigation() {
    const unsavedList: any = [];
    if (isIpAddressUpdated) {
      if (isIpAddressUpdated) {
        unsavedList.push("IP Whitelisting");
      }
      setSaveAllPopUp((saveAllPopUp: any) => ({
        ...saveAllPopUp,
        show: true,
        unsavedSettings: unsavedList,
      }));
      return;
    }
    history(`/application/manage-apps/${appId}`);
  }

  function onAddIpAddress(ipAddresses: string) {
    if (ipAddresses.length > 0) {
      let inValidIpCount = 0;
      let ipAddressExists = 0;
      const ipArray: any = [];
      if (ipAddresses.charAt(ipAddresses.length - 1) === ",") {
        setError((error) => ({
          ...error,
          ipAddress: "IP address cannot start with a ,",
        }));
        return;
      }
      const ips = ipAddresses.split(",");
      ips.map((ip: string) => {
        if (
          ipArray.includes(ip) ||
          listOfIpAddress.includes(ip) ||
          listOfRemovedIpAddress.includes(ip)
        ) {
          ipAddressExists++;
          return ipAddressExists;
        }
        if (!isValidIp(ip)) {
          inValidIpCount++;
          return inValidIpCount;
        }
        return ipArray.push(ip);
      });
      if (ipAddressExists > 0) {
        setError((error) => ({
          ...error,
          ipAddress: "This IP Address already exists",
        }));
        return;
      }
      if (inValidIpCount > 0) {
        setError((error) => ({
          ...error,
          ipAddress: "Enter a valid IP Address",
        }));
        return;
      }
      setIsIpAddressUpdated(true);
      setListOfIpAddress(listOfIpAddress.concat(ips));
      setIPAddresses("");
    }
  }

  async function handleAddIpAddressWithZpin(
    zpin: string,
    otp: string,
    setInvalidZpinError: any
  ) {
    setButtonLoading(true);
    try {
      let response: { ip_whitelisted?: string[] } | undefined;
      if (zpin || otp) {
        const payload: Record<string, unknown> = {
          ip_whitelisted: toggleOtpVerificationPopUp.ips,
        };
        if (zpin) payload.zpin = zpin;
        if (otp) {
          payload.otp = otp;
          payload.relay_id = relayId;
        }
        response = (await callApi(`/apps/${appId}`, {
          method: "PUT",
          data: payload,
        })) as { ip_whitelisted?: string[] };
      }
      setButtonLoading(false);
      setToggleResetOtp(false);
      setToggleOtpVerificationPopUp((toggleOtpVerificationPopUp: any) => ({
        ...toggleOtpVerificationPopUp,
        toggle: false,
      }));
      toastTimeout(true, "success", "IP Whitelisting successfully saved");
      const { ip_whitelisted = [] } = response ?? {};

      setListOfIpAddress(ip_whitelisted);
      setUpdatedListOfIpAddress(ip_whitelisted);
      setAllIpWhitelisted(
        ip_whitelisted.length !== 0 && ip_whitelisted[0] !== "ALL"
      );
      setSavedIpCount(ip_whitelisted[0] === "ALL" ? 0 : ip_whitelisted.length);
      setIsIpAddressUpdated(false);
      setListOfRemovedIpAddress([]);

      // if (!toggleOtpVerificationPopUp.ips.includes("ALL")) {
      //   setEnableAddingIpAddress(!enableAddingIpAddress);
      // }
    } catch (err: any) {
      setButtonLoading(false);
      const errorMessage = err?.message || err?.response?.data?.err || "";
      setErrorMessage(errorMessage);
      setInvalidZpinError(errorMessage);
    }
  }

  async function sendOtp(purpose: string) {
    try {
      const res = await sendAuthOtp(callApi, purpose);
      const { relay_id } = res;
      setRelayId(relay_id);
      return relay_id;
    } catch (err: any) {
      toastTimeout(true, "error", err.message);
      return;
    }
  }
  useTitle("Zoop Customer Platform | App Settings");

  return (
    <div style={{ background: "#F3F4F6" }}>
      {saveAllPopUp.show && (
        <UnsavedChangesPopUp
          unsavedSettingNames={saveAllPopUp.unsavedSettings}
          onDiscardChanges={() => {
            history(`/application/manage-apps/${appId}`);
          }}
          onCancel={() => {
            setSaveAllPopUp((saveAllPopUp) => ({
              ...saveAllPopUp,
              show: false,
            }));
          }}
        />
      )}
      {toggleOtpVerificationPopUp.toggle && (
        <ZpinMainPopup
          error={errorMessage}
          setError={(value: any) => setErrorMessage(value)}
          zpinExists={zpinExists}
          updateZpinStatus={() => setZpinExists(true)}
          toggleResetOtp={toggleResetOtp}
          setToggleResetOtp={(value: boolean) => setToggleResetOtp(value)}
          resendOtp={(purpose: string = OTP_PURPOSE.UPDATING_IP_LIST) =>
            sendOtp(purpose)
          }
          isLoading={buttonLoading}
          purpose={OTP_PURPOSE.UPDATING_IP_LIST}
          onCancel={() => {
            setErrorMessage(null);
            setToggleOtpVerificationPopUp(
              (toggleOtpVerificationPopUp: any) => ({
                ...toggleOtpVerificationPopUp,
                toggle: false,
                // ips: listOfIpAddress,
              })
            );
          }}
          onVerifyOtp={(zpin: string, otp: string, setInvalidOtpError: any) =>
            handleAddIpAddressWithZpin(zpin, otp, setInvalidOtpError)
          }
          handleZpinAuth={(
            zpin: string,
            otp: string,
            setInvalidZpinError: any
          ) => handleAddIpAddressWithZpin(zpin, otp, setInvalidZpinError)}
          relayId={relayId}
        />
      )}
      <div className={`${Styles.background}`}>
        {/* <div className="d-flex justify-content-between align-items-center px-3 pl-5">
          <DarkLogoSVG />
          <TopBar />
        </div> */}
        <div className="px-4 pt-4 pb-2 mx-3">
          <div
            {...testIdProps("manage-apps-settings-back")}
            className="d-flex align-items-center"
            onClick={() => handleBackNavigation()}
            style={{ cursor: "pointer" }}
          >
            <div className={`px-1 ${Styles.rotateRight}`}>
              <ArrowUp color={BLACKCOLOR} />
            </div>
            <p className={"mb-0 px-2 heading_text"}>App Settings</p>
          </div>
        </div>
        <div className="">
          <div
            className={"d-flex justify-content-center align-items-center pt-3"}
          >
            <Accordion
              defaultActiveKey="0"
              activeKey={activeKey}
              className={`${Styles.formWidth} py-2`}
            >
              {/* IP whitelist Section  */}
              <div className="py-2">
                <CustomToggle
                  eventKey="1"
                  onClick={() => setActiveKey("1")}
                  header="IP Whitelisting"
                />
                <Accordion.Collapse eventKey="1">
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <IpWhiteListing
                      zpinExists={zpinExists}
                      isIpAddressUpdated={isIpAddressUpdated}
                      setIsIpAddressUpdated={(value: boolean) =>
                        setIsIpAddressUpdated(value)
                      }
                      onAddingMultipleIpAddress={(value: string) =>
                        onAddIpAddress(value)
                      }
                      listOfIpAddress={listOfIpAddress}
                      removeIpAddress={(ipAddress: string) =>
                        setListOfIpAddress(
                          listOfIpAddress.filter((ip: any) => {
                            return ipAddress !== ip;
                          })
                        )
                      }
                      addIpAddressOnceRemoved={(ipAddress: string) => {
                        setListOfIpAddress(listOfIpAddress.concat(ipAddress));
                      }}
                      ipAddresses={ipAddresses}
                      setIPAddresses={(value: string) => setIPAddresses(value)}
                      enableAddingIpAddress={enableAddingIpAddress}
                      setEnableAddingIpAddress={(value: boolean) =>
                        setEnableAddingIpAddress(value)
                      }
                      error={error.ipAddress}
                      setError={(value: string) => {
                        setError((error) => ({
                          ...error,
                          ipAddress: value,
                        }));
                      }}
                      onCancel={() => {
                        setIPAddresses("");
                        setError((error) => ({
                          ...error,
                          ipAddress: "",
                        }));
                        setListOfIpAddress(updatedListOfIpAddress);
                        setAllIpWhitelisted(
                          updatedListOfIpAddress.length !== 0
                        );
                      }}
                      onSubmit={(value: any) => {
                        if (!value.withZpin) setRelayId(value.relay_id);
                        setError((error) => ({
                          ...error,
                          ipAddress: "",
                        }));
                        setErrorMessage(null);
                        setIPAddresses("");
                        setToggleOtpVerificationPopUp(
                          (toggleOtpVerificationPopUp: any) => ({
                            ...toggleOtpVerificationPopUp,
                            toggle: true,
                            ips: value.ips.length !== 0 ? value.ips : ["ALL"],
                          })
                        );
                      }}
                      allIpWhitelisted={allIpWhitelisted}
                      setToggleAllIpWhitelisting={(value: boolean) => {
                        setAllIpWhitelisted(value);
                        setListOfIpAddress([]);
                      }}
                      listOfRemovedIpAddress={listOfRemovedIpAddress}
                      setListOfRemovedIpAddress={(value: any) =>
                        setListOfRemovedIpAddress(value)
                      }
                      savedIpCount={savedIpCount}
                    />
                  </div>
                </Accordion.Collapse>
              </div>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppSettings;
